<template>
  <v-app id="login" class="primary darken-4">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img
                    src="/images/logo/jaque-128.png"
                    alt="Sistema Administración Interna"
                    width="120"
                    height="120"
                  />
                  <h3 style="color: red">V. {{ this.$store.state.version }}</h3>
                  <h1 class="flex my-2 primary--text">INTRODUCE TU PIN</h1>
                </div>
                <v-layout align-center justify-center>
                  <v-flex xs12 sm8 md3 lg3>
                    <v-text-field
                      ref="pin1"
                      type="password"
                      maxlength="1"
                      height="150"
                      class="font-big"
                      solo
                      outline
                      v-model="pin.pin1"
                      v-on:keyup="focusPin2"
                      v-on:keyup.delete="focusPin1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm8 md3 lg3>
                    <v-text-field
                      ref="pin2"
                      type="password"
                      maxlength="1"
                      height="150"
                      class="font-big"
                      solo
                      outline
                      v-model="pin.pin2"
                      v-on:keyup="focusPin3"
                      v-on:keyup.delete="focusPin1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm8 md3 lg3>
                    <v-text-field
                      ref="pin3"
                      type="password"
                      maxlength="1"
                      height="150"
                      class="font-big"
                      solo
                      outline
                      v-model="pin.pin3"
                      v-on:keyup="focusPin4"
                      v-on:keyup.delete="focusPin2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm8 md3 lg3>
                    <v-text-field
                      ref="pin4"
                      type="password"
                      maxlength="1"
                      height="150"
                      class="font-big"
                      solo
                      outline
                      v-model="pin.pin4"
                      v-on:keyup="focusPin5"
                      v-on:keyup.delete="focusPin3"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm8 md3 lg3>
                    <v-text-field
                      ref="pin5"
                      type="password"
                      maxlength="1"
                      height="150"
                      class="font-big"
                      solo
                      outline
                      v-model="pin.pin5"
                      v-on:keyup.enter="login"
                      v-on:keyup.delete="focusPin4"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-btn icon>
                  <v-icon color="blue">fa fa-facebook-square fa-lg</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color="red">fa fa-google fa-lg</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color="light-blue">fa fa-twitter fa-lg</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  block
                  color="primary darken-4"
                  @click="login"
                  :loading="loading"
                  >Iniciar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
       
      </v-container>
    </v-content>
    <snack-bar></snack-bar>
  </v-app>
</template>

<script>
import authService from "@/services/authService";
import sistemaService from "@/services/sistemaService";

import snackBar from "@/components/SnackBar";

export default {
  components: {
    snackBar,
  },
  data: () => ({
    loading: false,
    pin: {
      pin1: "",
      pin2: "",
      pin3: "",
      pin4: "",
      pin5: "",
    },
    showDialogTwo: false,
  }),
  created() {
    sistemaService.getVersion().then((result) => {
      this.$store.state.version = result;
    });
  },
  methods: {
    focusPin1() {
      let self = this;
      self.$refs.pin1.focus();
    },
    focusPin2() {
      let self = this;
      self.$refs.pin2.focus();
    },
    focusPin3() {
      let self = this;
      self.$refs.pin3.focus();
    },
    focusPin4() {
      let self = this;
      self.$refs.pin4.focus();
    },
    focusPin5() {
      let self = this;
      self.$refs.pin5.focus();
    },
    login() {
      let self = this;
      
      this.loading = true;
      let pin = `${self.pin.pin1}${self.pin.pin2}${self.pin.pin3}${self.pin.pin4}${self.pin.pin5}`;

      authService
        .publicLogin(pin)
        .then((result) => {
          if(result.success){
              localStorage.setItem("esAnonimo", "true");
              localStorage.setItem("tokenAcceso", result.tokenAcceso);
              localStorage.setItem("usuarioId", result.usuarioId);

              self.$nextTick(() => {
                  this.$router.push({ path: "public-home" });
              });

          }else{
          self.$store.state.snackbar.color = "error";
          self.$store.state.snackbar.text = "El PIN ingresado no existe";
          self.$store.state.snackbar.visible = true;
          }
        })
        .catch((e) => {
          console.log(e);
          self.$store.state.snackbar.color = "error";
          self.$store.state.snackbar.text = e.response.data.error;
          self.$store.state.snackbar.visible = true;
        })
        .finally((r) => {
          self.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.font-big {
  font-size: 80px;
}
.font-big input {
  margin-left: 20px !important;
}
</style>
